import React from "react";
import classNames from "classnames";

interface Props {
  svg: string;
  className?: string;
}

export default class SvgIcon extends React.Component<Props, {}> {
  public render() {
    return (
      <div className={classNames("svg-icon", this.props.className)}>
        <svg viewBox="0 0 32 32" preserveAspectRatio="xMidYMid" dangerouslySetInnerHTML={{ __html: this.props.svg }} />
        {this.props.children}
      </div>
    );
  }
}

export const DEFAULT_ICON_SVG = `<svg viewBox="0 0 20 16">
  <path d="M19.25 0h-6c-0.412 0-0.989 0.239-1.28 0.53l-7.439 7.439c-0.292 0.292-0.292 0.769 0 1.061l6.439 6.439c0.292 0.292 0.769 0.292 1.061 0l7.439-7.439c0.292-0.292 0.53-0.868 0.53-1.28v-6c0-0.412-0.337-0.75-0.75-0.75zM15.5 6c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z"></path>
  <path d="M2 8.5l8.5-8.5h-1.25c-0.412 0-0.989 0.239-1.28 0.53l-7.439 7.439c-0.292 0.292-0.292 0.769 0 1.061l6.439 6.439c0.292 0.292 0.769 0.292 1.061 0l0.47-0.47-6.5-6.5z"></path>
</svg>`;
